import type { OrganizationalUnit as OrganizationalUnitModel } from '@/adapters/catalogv1.g';

export function extractOrganizationalUnit(model: OrganizationalUnitModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    ref: model.ou_ref ?? '',
    name: model.name ?? '',
    description: model.description,
    type: model.type,
    costCenter: model.cost_center,
    parentOuRef: model.parent_ou_ref,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogOrganizationalUnit = ReturnType<
  typeof extractOrganizationalUnit
>;
